import { getAccountId } from './common';
import getAxios from './common/header';
import { postApi, getApi } from './common/apis';
import { directoryTree } from './common/directoryCode';

/**
 * @typedef {Object} ApiResponse
 * @property {boolean} success - Whether the API call was successful
 * @property {any} data - The response data
 * @property {string} message - Success or error message
 * @property {string|null} errorCode - Error code if any
 * @property {string|null} errorMessage - Error message if any
 */

export default class MessagingService {
    // Get details of a specific thread
    async getThreadDetails(threadId) {
        try {
            const response = await getApi(`v1/thread/${threadId}`);
            return response;
        } catch (err) {
            console.error('Error', err.stack);
            return {
                success: false,
                data: null,
                message: 'Failed to get thread details',
                errorCode: err.code,
                errorMessage: err.message
            };
        }
    }

    // Get messages for a specific thread
    async getThreadMessages(encId) {
        try {
            const response = await getApi(`v1/thread/${encId}/messages`);
            return response;
        } catch (err) {
            console.error('Error', err.stack);
            return {
                success: false,
                data: null,
                message: 'Failed to get thread messages',
                errorCode: err.code,
                errorMessage: err.message
            };
        }
    }

    // Add a new message to a thread
    async addMessageToThread(threadId, message, encryptionId, attachments = []) {
        try {
            const body = {
                htmlMessage: message
            };
            
            if (attachments && attachments.length > 0) {
                body.attachments = attachments;
            }
            
            const response = await postApi(
                `v1/thread/${threadId}/message?id=${encryptionId}`,
                JSON.parse(JSON.stringify(body))
            );
            return response;
        } catch (err) {
            console.error('Error', err.stack);
            return {
                success: false,
                data: null,
                message: 'Failed to add message to thread',
                errorCode: err.code,
                errorMessage: err.message
            };
        }
    }

    // Get list of threads for a specific RFP
    async getThreadList(encryptionId) {
        try {
            const response = await getApi(`v1/rfp/threads?id=${encryptionId}`);
            return response;
        } catch (err) {
            console.error('Error', err.stack);
            return {
                success: false,
                data: [],
                message: 'Failed to get thread list',
                errorCode: err.code,
                errorMessage: err.message
            };
        }
    }

    // Create a new thread for an RFP
    async createNewThread(encryptionId, subject, message, attachments = []) {
        try {
            const body = {
                subject: subject,
                message: message
            };
            if (attachments && attachments.length > 0) {
                body.attachments = attachments;
            }
            console.log('Sending createNewThread request with body:', body);
            const response = await postApi(
                `v1/rfp/thread?id=${encryptionId}`,
                JSON.parse(JSON.stringify(body))
            );
            console.log('createNewThread API response:', response);
            return response;
        } catch (err) {
            console.error('Error', err.stack);
            return {
                success: false,
                data: null,
                message: 'Failed to create new thread',
                errorCode: err.code,
                errorMessage: err.message
            };
        }
    }

    // Get presigned URL for file upload
    async getPresignedUrlForAttachment(fileName) {
        try {
            const response = await getApi(`v1/message-attachment/upload-url?fileName=${encodeURIComponent(fileName)}`);
            return response;
        } catch (err) {
            console.error('Error', err.stack);
            return {
                success: false,
                data: null,
                message: 'Failed to get presigned URL',
                errorCode: err.code,
                errorMessage: err.message
            };
        }
    }

    // Get download URL for file attachment
    async getFileDownloadUrl(attachmentId) {
        try {
            const response = await getApi(`v1/file/${attachmentId}`);
            return response;
        } catch (err) {
            console.error('Error', err.stack);
            return {
                success: false,
                data: null,
                message: 'Failed to get download URL',
                errorCode: err.code,
                errorMessage: err.message
            };
        }
    }
}
